module.exports = __webpack_public_path__ + "static/img/t26.25aa55b3.png";